import React from "react";
import "./FreeText.scss";

interface FreeTextProps {
  content: string;
}

const FreeText: React.FC<FreeTextProps> = ({ content }) => {
        return (
          <pre className="quill-rendered-content bg-white">
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </pre>
        );
      };
      

export default FreeText;
